import { Formik } from "formik";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";

export function SystemUserEditForm({ 
  systemUser,
  btnRef,
  saveSystemUser
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={systemUser}
      onSubmit={(values) => saveSystemUser(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Adı
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="surname">
            <Form.Label column sm={2}>
              Soyadı
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.surname} placeholder="Soyadı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="phone">
            <Form.Label column sm={2}>
              Telefon
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.phone} placeholder="Telefon" onChange={handleChange} />
            </Col>
          </Form.Group>
                        
          <Form.Group as={Row} controlId="email">
            <Form.Label column sm={2}>
              Email
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.email} placeholder="Email" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="isSuperAdmin">
            <Form.Label column sm={2}>
              Super Admin
            </Form.Label>
            <Col sm={10}>
              <Switch checked={values.isSuperAdmin} onChange={handleChange("isSuperAdmin")} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="isActive">
            <Form.Label column sm={2}>
              Aktif mi?
            </Form.Label>
            <Col sm={10}>
              <Switch checked={values.isActive} onChange={handleChange("isActive")} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}